export default "__VITE_PUBLIC_ASSET__6b37d23a__"